import React, { useState } from 'react';

function toCSV(rows, columns) {
  const header = columns.map(c => `"${c.label}"`).join(',');
  const body = rows.map(row =>
    columns.map(c => {
      const val = c.get(row);
      if (val == null || val === '') return '""';
      return `"${String(val).replace(/"/g, '""')}"`;
    }).join(',')
  ).join('\n');
  return header + '\n' + body;
}

function downloadCSV(csv, filename) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

function downloadPDF(rows, columns, title) {
  const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>${title}</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body { font-family: Arial, sans-serif; font-size: 11px; color: #1a1a1a; padding: 24px; }
  h1 { font-size: 18px; margin-bottom: 4px; color: #0d0d0d; }
  .meta { font-size: 11px; color: #666; margin-bottom: 20px; }
  table { width: 100%; border-collapse: collapse; font-size: 10px; }
  th { background: #1a1e25; color: #c8a96e; text-align: left; padding: 7px 10px; font-size: 9px; text-transform: uppercase; letter-spacing: 0.05em; }
  td { padding: 6px 10px; border-bottom: 1px solid #e8e8e8; color: #333; vertical-align: top; }
  tr:nth-child(even) td { background: #f7f7f7; }
  .footer { margin-top: 20px; font-size: 9px; color: #999; }
</style>
</head>
<body>
<h1>Liongate Planning — ${title}</h1>
<div class="meta">Exported ${new Date().toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })} · ${rows.length} records</div>
<table>
  <thead><tr>${columns.map(c => `<th>${c.label}</th>`).join('')}</tr></thead>
  <tbody>
    ${rows.map(row => `<tr>${columns.map(c => `<td>${c.get(row) ?? '—'}</td>`).join('')}</tr>`).join('')}
  </tbody>
</table>
<div class="footer">Liongate Planning Ltd · Confidential</div>
</body>
</html>`;

  const blob = new Blob([html], { type: 'text/html;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const win = window.open(url, '_blank');
  if (win) {
    win.onload = () => { win.print(); };
  }
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export default function ExportButtons({ rows, columns, title, filename }) {
  const [open, setOpen] = useState(false);

  const exportCSV = () => {
    downloadCSV(toCSV(rows, columns), `${filename}_${new Date().toISOString().slice(0,10)}.csv`);
    setOpen(false);
  };

  const exportPDF = () => {
    downloadPDF(rows, columns, title);
    setOpen(false);
  };

  return (
    <div style={{ position: 'relative' }}>
      <button
        className="btn-ghost"
        style={{ fontSize: 12, padding: '8px 14px', display: 'flex', alignItems: 'center', gap: 6 }}
        onClick={() => setOpen(v => !v)}
      >
        ↓ Export
      </button>
      {open && (
        <>
          <div style={{ position: 'fixed', inset: 0, zIndex: 50 }} onClick={() => setOpen(false)} />
          <div style={{
            position: 'absolute', top: '100%', right: 0, marginTop: 6, zIndex: 60,
            background: 'var(--bg2)', border: '1px solid var(--border2)',
            borderRadius: 'var(--radius)', boxShadow: 'var(--shadow)', minWidth: 160, overflow: 'hidden'
          }}>
            <button onClick={exportCSV} style={{
              display: 'block', width: '100%', padding: '10px 16px', textAlign: 'left',
              background: 'transparent', color: 'var(--text)', fontSize: 13, border: 'none',
              cursor: 'pointer', fontFamily: 'inherit'
            }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--bg3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              📄 Export CSV
            </button>
            <button onClick={exportPDF} style={{
              display: 'block', width: '100%', padding: '10px 16px', textAlign: 'left',
              background: 'transparent', color: 'var(--text)', fontSize: 13, border: 'none',
              cursor: 'pointer', fontFamily: 'inherit'
            }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--bg3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              🖨 Export PDF
            </button>
          </div>
        </>
      )}
    </div>
  );
}
